<template>
  <v-card flat>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      :items-per-page = '5'
      :search="search"
      :dense="dense"
      :sort-by="initSort"
    >
      <template v-slot:top>
        <v-toolbar v-if="header || hasSearch" flat>
          <v-toolbar-title v-if="header">{{ header }}</v-toolbar-title>
          <v-spacer v-if="header"/>
          <v-text-field
            :disabled="loading || disabled"
            v-model="search"
            v-if="hasSearch"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-toolbar>
        <v-alert v-if="errorMessage" text dense type="error">
          {{ errorMessage }}
        </v-alert>
      </template>
      <template v-if="hasAction" v-slot:item.action="{ item }">
        <v-btn v-show="hasRemoveAction" :disabled="loading || disabled" text icon color="delete" @click="$emit('on-click-remove', item)"><v-icon>mdi-close</v-icon></v-btn>
        <v-btn v-show="hasAddAction" :disabled="loading || disabled" text icon color="add" @click="$emit('on-click-add', item)"><v-icon>mdi-plus</v-icon></v-btn>
      </template>

      <template v-slot:item.transientFamily="{ item }">
        <v-icon>{{getFamilyIcon(item.unit.transientFamily)}}</v-icon>
      </template>

    </v-data-table>
  </v-card>
</template>

<script>
import familyIcon from '../mixins/familyIcon'

export default {
  name: 'ItemListInfo',
  mixins: [familyIcon],
  props: {
    items: {
      type: Array
    },
    headers: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasSearch: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasAction: {
      type: Boolean,
      default: false
    },
    hasAddAction: {
      type: Boolean,
      default: false
    },
    hasRemoveAction: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initSort: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    search: ''
  }),
  methods: {
    resetData: function () {
      this.search = ''
    }
  },
  created () {
    if (this.hasAction) {
      this.headers.push(
        {
          text: '',
          align: 'right',
          value: 'action',
          sortable: false
        })
    }
  }
}
</script>

<style scoped>

</style>
